import { React, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from '@material-ui/core';
import { Chip, Grid } from '@mui/material';
import Cookies from 'js-cookie';
import useStyles from './styles';
import SubUsage from './SubUsage';
import { getClient } from '../../redux/Actions/clientInfo.action';
import InstanceName from '../../components/InstanceName';

export default function Usages() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);
    const allApps = useSelector((state) => state.applicationsReducer.allApps);
    const [isChatBotEnabled, setIsChatBotEnabled] = useState(false);

    const usageValsSearch = {
        minute: 60,
        hourly: 3500,
        monthly: 300000
    };

    const usageValsAnalytics = {
        minute: 50,
        hourly: 2500,
        monthly: 150000
    };

    const usageValsContent = {
        minute: 50,
        hourly: 2500,
        monthly: 150000
    };

    const usageValsChatbot = {
        minute: 0,
        hourly: 0,
        monthly: 0
    };
    //
    const usageValsGPT = {
        minute: 60,
        hourly: 3500,
        monthly: 100000
    };
    const [usages, setUsages] = useState({
        apiUsagePerSecond: 5,
        searchApiLimit: usageValsSearch,
        analyticsApiLimit: usageValsAnalytics,
        contentApiLimit: usageValsContent,
        chatbotApiLimit: usageValsChatbot,
        gptApiLimit:usageValsGPT
    });

    useEffect(() => {
        if (clientInfo.usages) {
            setUsages({
                apiUsagePerSecond: clientInfo.usages.apiUsagePerSecond,
                searchApiLimit: clientInfo.usages.searchApiLimit,
                analyticsApiLimit: clientInfo.usages.analyticsApiLimit,
                contentApiLimit: clientInfo.usages.contentApiLimit,
                chatbotApiLimit: clientInfo.usages.chatbotApiLimit,
                gptApiLimit:clientInfo.usages.gptApiLimit
            });
        }
    }, [clientInfo]);

    useEffect(() => {
        const chatBotAppId = allApps.find((aP) => aP.name.toLowerCase() === 'chatbot analytics');
        if (
            chatBotAppId &&
            clientInfo.installedApps &&
            clientInfo.installedApps.includes(chatBotAppId._id)
        ) {
            setIsChatBotEnabled(true);
        } else {
            setIsChatBotEnabled(false);
        }
    }, [clientInfo, allApps]);

    useEffect(() => {
        const tenantId = Cookies.get('tenantId') || clientInfo.tenantId;
        dispatch(getClient(tenantId));
    }, [dispatch, clientInfo.tenantId]);

    return (
        <>
            <div className={classes.nameResponsive}>
                <InstanceName />
            </div>
            <div className={classes.usageContainer}>
                <Grid container>
                    <div className={classes.secondHeadApi}>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.innerheadApi}>
                                <Chip
                                    style={{
                                        background: '#EDEFF1 ',
                                        color: ' #4E4E4E'
                                    }}
                                    className={classes.innerText}
                                    label="CONCURRENT API REQUESTS"
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.nextSet}>
                                <div className={classes.formTextApi}>Limits Per Second</div>
                                <Typography variant="subtitle1" className={classes.sectionValue}>
                                    {usages.apiUsagePerSecond}
                                </Typography>
                            </div>
                        </Grid>
                    </div>
                </Grid>
                <div className={classes.boxSet}>
                    <Grid container>
                        <Grid item xs={12} sm={6} md={4}>
                            <SubUsage label="Search" value={usages.searchApiLimit} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <SubUsage label="Analytics" value={usages.analyticsApiLimit} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <SubUsage label="Content" value={usages.contentApiLimit} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <SubUsage label="GPT" value={usages.gptApiLimit} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            {isChatBotEnabled && (
                                <SubUsage
                                    label="ChatBot Analytics"
                                    value={usages.chatbotApiLimit}
                                />
                            )}
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    );
}
